<template>
   <span class="badge rounded-pill bg-success">
      {{ name }}
   </span>
</template>
<script>
export default {
   props: ["name"],
};
</script>